<template>
  <b-container class="pt-2">
    <b-row v-if="loading">
      <font-awesome-icon icon="spinner" size="lg" spin/>
    </b-row>
    <b-row v-if="!loading && !saving" class="text-left">
      <ol>
        <li v-for="recommendation in recommendations" :key="recommendation.id">
          <font-awesome-icon icon="edit" :id="`edit-me-${recommendation.id}`" size="sm" @click="editingId=recommendation.id;newRecommendation=recommendation.recommendation;"/>
          <span v-html="recommendation.recommendation"/>
        </li>
      </ol>
    </b-row>
    <b-row class="pt-3 text-left">
      <b-col>
        <b-form-group 
          id="recommendationgroup"
          breakpoint="md"
          label="Add Recommendation"
          label-for="recommendation"
          validated
        >
          <wysiwyg v-model="newRecommendation" id="recommendation"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="pt-3">
      <b-col>
        <b-button variant="success" @click="save()" :disabled="!newRecommendation">{{ editingId ? 'Update' : 'Add' }}</b-button>
      </b-col>
      <b-col v-if="editingId" >
        <vue-confirmation-button ref="deleteButton" :css="'btn btn-danger'" :messages="['Delete','Are you sure?','Deleted, reloading.....']" @confirmation-success="deleteItem();"/>
      </b-col>
      <b-col>
        <b-button variant="default" @click="newRecommendation=''; editingId=null;" v-if="newRecommendation || editingId">Cancel</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import * as API from "@/services/API";
import vueConfirmationButton from 'vue-confirmation-button';

export default {
    name: 'RecommendationsList',
    props: ['surveyRunId'],
    components: { vueConfirmationButton },
    data: function () {
        return {
            recommendations: [],
            newRecommendation: '',
            loading: true,
            saving: false,
            editingId: null
        }
    },
    created: function () {
      this.load();
    },
    methods: {
      save(){
        this.saving = true;
        return API.saveRecommendation(this.editingId, this.surveyRunId,this.newRecommendation).then(response => {
          this.newRecommendation = '';
          this.editingId = null;
          this.saving = false;
          this.load();
        });
      },
      load() {
        this.loading = true;
        return API.getRecommendations(this.surveyRunId).then(response => {
          this.recommendations = response;
          this.loading = false;
        });
      },
      deleteItem() {
        this.loading = true;
        const deleteButton = this.$refs.deleteButton;
        return API.deleteRecommendation(this.editingId, this.surveyRunId).then(response => {
          deleteButton.reset();
          this.newRecommendation = '';
          this.editingId = null;
          this.load();
        });
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/RecommendationsList.vue